<template>
  <list mode="holdback" :items="holdbacks" @delete="onDelete" />
</template>

<script>
import List from "@/components/list"
import Holdbacks from "@/api/holdback"
export default {
  name: "Holdbacks",
  components: { List },
  data() {
    return {
      holdbacks: []
    }
  },
  mounted() {
    Holdbacks.list().then(response => {
      this.holdbacks = response.data
    }).finally(() => this.setBusy(false))
  },
  methods: {
    onDelete(items) {
      Holdbacks.delete({ items: items }).then(response => {
        this.notify(response.data)
        this.refresh()
      })
    }
  }
}
</script>